import { Sparkles } from "lucide-react";

export function AiScoreInfoBanner() {
  return (
    <div className="mt-2 flex items-start gap-3 p-5 bg-teal-50 rounded-xl border border-teal-100 max-w-2xl">
      <div className="bg-white p-1.5 rounded-full border border-teal-100 shadow-sm shrink-0">
        <Sparkles className="size-5 text-teal-600" />
      </div>
      <div>
        <h4 className="text-sm font-bold text-teal-800 mb-1">AIスコアの算出方法について</h4>
        <p className="text-sm text-teal-700/80 leading-relaxed">
          AI
          は履歴書・面談結果を解析し、職務要件（スキル）、性格特性、企業文化との適合度を総合スコアとして算出します。スコアはあくまで参考指標であり、最終判断は採用担当者が行ってください。
        </p>
      </div>
    </div>
  );
}
